$(document).ready(function() {
  var file_uploads = document.querySelector('#file-upload')
  if (file_uploads != null) {
    file_uploads.addEventListener('change', function (event) {
      let image = document.querySelector('#output');
      image.src = URL.createObjectURL(event.target.files[0]);
    });
  }
});
